import React from "react";
import { useLocation, Link } from "react-router-dom";

export default function StaysConfirmed() {
  const q = new URLSearchParams(useLocation().search);
  const amount = q.get("amount") || "—";
  const currency = q.get("currency") || "AED";
  const provider = q.get("provider") || "BNPL";
  const offerId = q.get("offerId") || q.get("offer_id");
  const ref = q.get("ref") || "STAYS-" + Math.random().toString(36).slice(2,8).toUpperCase();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-xl p-8">
        <div className="text-center mb-6">
          <div className="w-16 h-16 mx-auto mb-4 gradient-bg rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-heading font-semibold mb-2 text-flexaura-navy">
            Hotel Booking Confirmed!
          </h2>
          <p className="text-muted-foreground">
            Thanks! We're confirming your hotel booking. Your installment payment has been authorized.
          </p>
        </div>

        <div className="border border-border rounded-2xl p-6 card-shadow bg-card space-y-4">
          <div>
            <div className="text-sm text-muted-foreground">Booking Reference</div>
            <div className="text-lg font-medium text-flexaura-navy">{ref}</div>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <div className="text-muted-foreground">Amount</div>
              <div className="font-medium">{currency} {Number(amount).toLocaleString()}</div>
            </div>
            <div>
              <div className="text-muted-foreground">Payment via</div>
              <div className="font-medium capitalize">{provider}</div>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <div className="text-sm text-muted-foreground">
              <p className="mb-2">
                📧 <strong>Confirmation email:</strong> You'll receive your hotel voucher and booking details via email shortly.
              </p>
              <p className="mb-2">
                🏨 <strong>Hotel contact:</strong> We're processing your booking with the hotel directly.
              </p>
              <p>
                ⏱️ <strong>Processing time:</strong> Most bookings are confirmed within 1-3 minutes.
              </p>
            </div>
          </div>

          <div className="text-xs text-muted-foreground pt-2 border-t border-border">
            If you don't receive a confirmation email within 30 minutes, please contact us at hector@flexaura.me.
            Have your booking reference ({ref}) ready.
          </div>
        </div>

        <div className="mt-6 flex gap-3 justify-center">
          <Link 
            to="/stays/search" 
            className="px-6 py-2 rounded-lg border border-border text-foreground hover:bg-accent smooth-transition"
          >
            Book Another Hotel
          </Link>
          <Link 
            to="/" 
            className="px-6 py-2 gradient-bg text-white rounded-lg hover:opacity-90 smooth-transition"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}